import { Component, Input } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { AlertService } from 'src/app/components/_alert/alert.service';
import { IApplication, IContract, IContrato, IDatosBasicosSolicitud, IDeudaSbifReport, IDeudaSbifReportRaw, IDSClienteReport, IDSClienteReportRaw, IGeneralReport, IIndicadorReport, IIndicadorReportRaw, IResultado, IRulesInput, ISolicitud, ITagReport } from 'src/app/interface/IFlujoLightTx';
import { FlujoCreditoLightService } from 'src/app/shared/services/flujo-credito-light.service';
import { UtilsService } from 'src/app/shared/services/utils.service';
import { forkJoin, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { FlujoCreditoLightModalConsolidadoComponent } from '../../components/flujo-credito-light-modal-consolidado/flujo-credito-light-modal-consolidado.component';
import { SalfaInfoRegcheqComponent } from './info-dialogs/salfa-info-regcheq/salfa-info-regcheq.component';
import { SalfaInfoTagComponent } from './info-dialogs/salfa-info-tag/salfa-info-tag.component';

type StatusClass = 'bg-success' | 'bg-danger' | 'bg-warning' | 'bg-info';

@Component({
    selector: 'app-plantilla-salfa-fc-light',
    templateUrl: './plantilla-salfa-fc-light.component.html',
    styleUrls: ['./plantilla-salfa-fc-light.component.scss']
})
export class PlantillaSalfaFcLightComponent {
    readonly SERVICE_KEYS = {
        BASIC_REPORT: 'basicReport',
        TAG_REPORT: 'tag',
        DEUDA_SBIF_REPORT: 'deudaSbif',
        DS_CLIENTE_REPORT: 'dsCliente',
        INDICADOR_REPORT: 'indicador',
        REGCHEQ_REPORT: 'regcheq',
    }

    private readonly StatusDisplay = {
        OK: 'OK',
        NO_OK: 'NO OK',
    } as const;

    private readonly RegCheqValues = {
        LOW: 'low',
        HIGH: 'high',
    } as const;

    private readonly REG_CHEQ_DISPLAY_MAP: Record<string, string> = {
        low: 'BAJO',
        high: 'ALTO',
    };

    readonly DIALOG_KEYS = {
        REPORTE_CONSOLIDADO: 'REPORTE_CONSOLIDADO',
        REGCHEQ: 'REGCHEQ',
        DEUDA_TAG: 'DEUDA_TAG',
    } as const;

    @Input() isModal = false;
    @Input() idTransaccion!: string;
    @Input() generalReport!: IGeneralReport;

    datosBasicosSolicitud?: IDatosBasicosSolicitud;
    resultado?: IResultado;
    rulesInput?: IRulesInput
    contratos?: IContract[]

    basicReport?: any;
    tagReport?: ITagReport;
    deudaSbifReport?: IDeudaSbifReport;
    dsClienteReport?: IDSClienteReport;
    indicadorReport?: IIndicadorReport;
    regCheqReport?: any;

    solicitudesDataSource: MatTableDataSource<ISolicitud> = new MatTableDataSource<ISolicitud>;

    solicitudesDisplayedColumns: string[] = ['creacion', 'modelo', 'per', 'kms', 'precio', 'estado'];

    contratosDataSource: MatTableDataSource<IContrato> = new MatTableDataSource<IContrato>;

    contratosDisplayedColumns: string[] = ['estado', 'creacion', 'valor', 'per'];

    periodDisplayText = '';
    vehicleValue = 0;
    deudaMorosaSemDisplayText = '';
    regCheqDisplayText = '';
    lastLineaCredito = 0;
    antiguedadDisplayText = '';
    antiguedadSemDisplayText = '';
    lastWrshb = 0;
    deudaSalfaSemDisplayText = '';

    cargaSemClass?: StatusClass;
    deudaMorosaSemClass?: StatusClass;
    regCheqClass?: StatusClass;
    tagSemClass?: StatusClass;
    lineaBancariaSemClass?: StatusClass;
    deudaBancariaSemClass?: StatusClass;
    deudaSbifShipRentaSemClass?: StatusClass;
    antiguedadSemClass?: StatusClass;
    deudaSalfaSemClass?: StatusClass;

    listaReportesPrincipales: any[] = [];
    listaReportesDerivados: any = {};

    private reportesModalConsolidado = {
        consolidadoTitular: null,
        basicReport: { reporte: null },
        deudaSbif: { reporte: null },
    };
    
    private consolidadoTitular: any = {};

    constructor(
        private flujoCreditoLightService: FlujoCreditoLightService,
        private alertService: AlertService,
        public dialog: MatDialog,
        private utilsService: UtilsService,
    ) { }

    ngOnInit(): void {
        this.datosBasicosSolicitud = this.generalReport.datosBasicosSolicitud;
        this.resultado = this.generalReport.calculos.resultado;
        this.rulesInput = this.generalReport.rulesInput;
        this.contratos = this.generalReport.rulesInput?.activeContracts;

        forkJoin({
            basic: this.flujoCreditoLightService.getReportByServiceKey(this.idTransaccion, this.SERVICE_KEYS.BASIC_REPORT)
                .pipe(catchError(err => {
                    this.alertService.error(`Error al obtener ${this.SERVICE_KEYS.BASIC_REPORT}: ${err?.error?.message}`);
                    return of(null);
                })),

            sbif: this.flujoCreditoLightService.getReportByServiceKey(this.idTransaccion, this.SERVICE_KEYS.DEUDA_SBIF_REPORT)
                .pipe(catchError(err => {
                    this.alertService.error(`Error al obtener ${this.SERVICE_KEYS.DEUDA_SBIF_REPORT}: ${err?.error?.message}`);
                    return of(null);
                })),
        })
        .subscribe(responses => {
            // === BASIC
            this.basicReport = responses.basic || {};
            this.reportesModalConsolidado.basicReport.reporte = this.basicReport;

            // === SBIF

            if (responses.sbif) {
                this.reportesModalConsolidado.deudaSbif.reporte = responses.sbif?.DeudaSistemaFinancieroReporte;
                this.deudaSbifReport = this.mapSbifReport(responses.sbif);
                this.setLastLineaCredito();
            }

            // === Consolidado
            this.consolidadoTitular = this.utilsService.crearConsolidadoTitular(
                [],
                null,
                this.reportesModalConsolidado
            );

            this.reportesModalConsolidado.consolidadoTitular = this.consolidadoTitular;

        });

        this.getReportByServiceKey(this.SERVICE_KEYS.TAG_REPORT);
        this.getReportByServiceKey(this.SERVICE_KEYS.DS_CLIENTE_REPORT);
        this.getReportByServiceKey(this.SERVICE_KEYS.INDICADOR_REPORT);
        this.getReportByServiceKey(this.SERVICE_KEYS.REGCHEQ_REPORT);

        this.setPeriodDisplay(this.rulesInput.application.period);
        this.setDeudaMorosaSemDisplayText(this.resultado.deudamorosasem);
        this.setRegCheqDisplayText(this.resultado.regcheq);
        this.setAntiguedadDisplayText(this.resultado.antiguedad);
        this.setAntiguedadSemDisplayText(this.resultado.antiguedasem);
        this.setDeudaSalfaSemDisplayText(this.resultado.deudasalfasem);

        this.cargaSemClass = this.getBackgroundClass(this.resultado.cargasem);
        this.lineaBancariaSemClass = this.getBackgroundClass(this.resultado.lineabancariasem);
        this.deudaBancariaSemClass = this.getBackgroundClass(this.resultado.deudabancariasem);
        this.deudaSbifShipRentaSemClass = this.getBackgroundClass(this.resultado.deudasbifshipRentasem);

        this.deudaMorosaSemClass = this.getOkNoOkClass(this.resultado.deudamorosasem);
        this.antiguedadSemClass = this.getOkNoOkClass(this.resultado.antiguedasem);
        this.deudaSalfaSemClass = this.getOkNoOkClass(this.resultado.deudasalfasem);

        this.regCheqClass = this.getRegCheqClass(this.resultado.regcheq);

        this.tagSemClass = this.getTagSemClass(this.resultado.tagsem);

        this.solicitudesDataSource.data = this.generalReport.rulesInput?.applications.map((application: IApplication) => {
            return {
                creacion: application.createdAt,
                kms: application.kilometers,
                per: application.period,
                modelo: application.carName,
                estado: application.status,
                precio: application.amount
            }
        });

        this.contratosDataSource.data = this.contratos.map((contract: IContract) => {
            return {
                creacion: contract.startDate,
                valor: contract.amount,
                per: contract.period,
                estado: contract.status
            }
        });
    }

    setPeriodDisplay(period: number): void {
        this.periodDisplayText = period === 1 ? '1 MES' : `${period} MESES`;
    }

    getReportByServiceKey(serviceKey: string): void {
        this.flujoCreditoLightService.getReportByServiceKey(this.idTransaccion, serviceKey).subscribe(
            report => {
                switch (serviceKey) {
                    case this.SERVICE_KEYS.TAG_REPORT:
                        this.tagReport = report;
                        break;
                    case this.SERVICE_KEYS.DS_CLIENTE_REPORT:
                        this.dsClienteReport = this.mapDsClienteReport(report);
                        this.setLastWrshb();
                        break;
                    case this.SERVICE_KEYS.INDICADOR_REPORT:
                        this.indicadorReport = report;
                        this.setVehicleValue();
                        break;
                    case this.SERVICE_KEYS.REGCHEQ_REPORT:
                        this.regCheqReport = report;
                        break;
                    default:
                        console.warn(`Error al obtener el reporte ${serviceKey}: clave no reconocida`);
                }
            },
            error => {
                this.alertService.error(`Error al obtener el reporte ${serviceKey}: ${error?.error?.message}`);
            }
        )
    }

    mapSbifReport(report: IDeudaSbifReportRaw): IDeudaSbifReport {
        return {
            items: report?.DeudaSistemaFinancieroReporte?.Documentos?.SbifOnline?.Reporte?.rowsMeses?.item
        }
    }

    mapDsClienteReport(report: IDSClienteReportRaw): IDSClienteReport {
        const rawResults = report?.DSClienteReport?.Reporte?.results;
        const resultsArray = Array.isArray(rawResults) ? rawResults : [];

        return {
            results: resultsArray.map(result => ({
                wrshb: result.Wrshb
            }))
        };
    }

    mapIndicadorReport(report: IIndicadorReportRaw): IIndicadorReport {
        return {
            valores: report.valores.map(val => ({ valor: Number(val.valor) }))
        }
    }

    setLastLineaCredito(): void {
        const items = this.deudaSbifReport?.items;

        if (!items || items.length === 0) return;

        const lastItem = items.at(-1);
        this.lastLineaCredito = Number(lastItem?.lineacredito);
    }

    setAntiguedadDisplayText(antiguedad: number | string): void {
        if (typeof antiguedad === 'number') {
            this.setAntiguedadDisplayTextFromNumber(antiguedad);
            return;
        }

        if (typeof antiguedad === 'string') {
            const fecha = new Date(antiguedad);

            if (!isNaN(fecha.getTime())) {
                this.setAntiguedadDisplayTextFromDate(fecha);
            } else {
                this.antiguedadDisplayText = '0 meses';
            }

            return;
        }
    }

    setAntiguedadDisplayTextFromNumber(antiguedad: number): void {
        if (antiguedad === 0) {
            this.antiguedadDisplayText = '0 meses';
            return;
        }

        if (antiguedad === 1) {
            this.antiguedadDisplayText = '1 mes';
            return;
        }

        this.antiguedadDisplayText = `${antiguedad.toFixed(2)} meses`;
    }

    setAntiguedadDisplayTextFromDate(antiguedad: Date): void {
        const today = new Date();
        let months;

        months = (today.getFullYear() - antiguedad.getFullYear()) * 12;
        months -= antiguedad.getMonth();
        months += today.getMonth();

        const diffMonths = months < 0 ? 0 : months;

        this.antiguedadDisplayText = `${diffMonths} ${diffMonths === 1 ? 'mes' : 'meses'}`;
    }

    setVehicleValue(): void {
        const { amount, currency } = this.rulesInput?.application || {};

        if (!amount || !currency) return;
        if (!this.indicadorReport) return;

        if (currency === 'CLP') {
            this.vehicleValue = amount;
            return;
        }

        if (currency === 'UF') {
            const lastValue = this.indicadorReport.valores.at(-1);
            this.vehicleValue = lastValue ? Math.round(amount * lastValue.valor) : 0;
        }
    }

    setDeudaMorosaSemDisplayText(deudaMorosaSem: number | null): void {
        if (deudaMorosaSem === 0) {
            this.deudaMorosaSemDisplayText = this.StatusDisplay.OK;
            return;
        }

        this.deudaMorosaSemDisplayText = this.StatusDisplay.NO_OK;
    }

    setAntiguedadSemDisplayText(antiguedadSem: number | null): void {
        if (antiguedadSem === 0) {
            this.antiguedadSemDisplayText = this.StatusDisplay.OK;
            return;
        }

        this.antiguedadSemDisplayText = this.StatusDisplay.NO_OK;
    }

    setRegCheqDisplayText(regCheq: string | null): void {
        this.regCheqDisplayText = this.REG_CHEQ_DISPLAY_MAP[regCheq ?? ''] ?? '';
    }

    setLastWrshb(): void {
        const results = this.dsClienteReport?.results;

        if (!results || results.length === 0) return;

        const lastItem = results.at(-1);
        this.lastWrshb = Number(lastItem?.wrshb);
    }

    setDeudaSalfaSemDisplayText(deudaSalfaSem: number | null): void {
        if (deudaSalfaSem === 0) {
            this.deudaSalfaSemDisplayText = this.StatusDisplay.OK;
            return;
        }

        this.deudaSalfaSemDisplayText = this.StatusDisplay.NO_OK;
    }

    getBackgroundClass(value: number | null | undefined): StatusClass {
        if (value === 0) return 'bg-success';
        if (value === 1) return 'bg-danger';
        if (value === 2) return 'bg-warning';
        return 'bg-info';
    }

    getOkNoOkClass(value: number | null | undefined): StatusClass {
        if (value === 0) return 'bg-success';
        return 'bg-danger';
    }

    getRegCheqClass(value: string | null | undefined): StatusClass {
        if (!value) return 'bg-info';
        if (value.toLowerCase() === this.RegCheqValues.LOW) return 'bg-success';
        if (value.toLowerCase() === this.RegCheqValues.HIGH) return 'bg-danger';
        return 'bg-info';
    }

    getTagSemClass(value: number | null | undefined): StatusClass {
        if (value === 0) return 'bg-success';
        if (value === 1) return 'bg-danger';
        if (value === 4) return 'bg-warning';
        return 'bg-info';
    }

    openModalConsolidado(): void {
        this.dialog.open(FlujoCreditoLightModalConsolidadoComponent, {
            maxWidth: '1200px',
            data: {
                rut: this.datosBasicosSolicitud?.rut,
                idTransaccion: this.idTransaccion,
                dataServicios: this.reportesModalConsolidado,
            }
        });
    }

    openModalRegCheq(): void {
        this.dialog.open(SalfaInfoRegcheqComponent, {
            width: '1200px',
            data: {
                reporte: this.regCheqReport,
            }
        });
    }

    openModalTag(): void {
        this.dialog.open(SalfaInfoTagComponent, {
            width: '1200px',
            data: {
                reporte: this.tagReport,
            }
        });
    }

}